import { QueryKey, useIsFetching } from '@tanstack/react-query';

export function useIsLoading(queryKey: QueryKey) {
  return useIsFetching({
    queryKey,
    predicate: query => typeof query.state.data === 'undefined',
  });
}
